<template>
  <SelectTableDialog
    :title="this.$t('futuresStrategy.collapseTitle.matchContractTitle')"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :confirmUnchecked="false"
    :API="contractAPI"
    :extraData="extraData"
    propCode="contractNo"
    width="1200px"
    @close="close"
    @confirm="confirm"
  ></SelectTableDialog>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/futuresStrategy/index';
  // import COMPANY_API from '@/api/masterData/company';
  import SelectTableDialog from '@/components/SelectTableDialog';
  import BASEAPI from '@/api/dataBase.js';
  // import SiruiSearch from '@/components/SiruiSearch';
  import XEUtils from 'xe-utils';
  export default {
    data() {
      return {
        defaultVisible: false,
        contractAPI: API.GET_LIST_API,
        extraData: {
          /* contractCategory: 'sales',
        contractStatus: 'ZT03', */
          //salesLadingFlag: 1,//限制只查询满足条件的明细 如销售合同 年度协议 意向单
          listContractDetailCategory: ['HT03', 'HT07'],
          listStatus: ['ZT03'],
          dataGroup: 'zjmi',
        }, //搜索额外传参
        departmentList: [],
        contractDetailList: [],
        load: false,
        hasExist: false,
        unCollectionQuantityTotal: 0,
        query: {
          productNo: null,
          contractStatus: null,
          contractBusinessDepartment: null,
        },
      };
    },
    components: {
      SelectTableDialog,
      // SiruiSearch,
    },

    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        contractList: function (state) {
          let salesList = state.dict.dictListMap.sales_contract_detail_category;
          let purchaseList = state.dict.dictListMap.purchase_contract_detail_category;
          return salesList.concat(purchaseList);
        },
      }),
      searchColumns() {
        // const departmentUrl = this.companyCode
        //   ? `${COMPANY_API.GET_COMPANY_DETAIL_API}/${this.companyCode}`
        //   : '';
        return [
          {
            // 合同编号
            prop: 'contractNo',
            name: this.$t('futuresStrategy.strategicContract.column.contractNo'),
            type: 'input',
          },
          //商品编码
          {
            prop: 'productNo',
            type: 'searchTableSpec',
            name: this.$t('futuresStrategy.strategicContract.column.productDesc'),
            searchType: 'goodsDetail',
            isMultiple: true,
            getSearchCode: 'productDetailCode',
          },

          //业务部门
          {
            prop: 'contractBusinessDepartment',
            type: 'select',
            name: this.$t('futuresStrategy.strategicContract.column.departmentName'),
            clearable: true,
            options: this.departmentList,
          },
        ];
      },
      columnList() {
        return [
          {
            prop: 'contractNo',
            label: this.$t('futuresStrategy.strategicContract.column.contractNo'),
          }, // 合同编号
          {
            prop: 'contractDetailCategory',
            label: this.$t('futuresStrategy.strategicContract.column.contractDetailCategory'),
            render: (value) => this.getSelectLabel(value, this.contractList),
          }, // 合同类型
          {
            prop: 'productDesc',
            label: this.$t('futuresStrategy.strategicContract.column.productDesc'),
          }, // 商品描述
          {
            prop: 'contractBusinessDepartmentName',
            label: this.$t('futuresStrategy.strategicContract.column.departmentName'),
          }, // 业务部门
          {
            prop: 'productQuantity',
            label: this.$t('futuresStrategy.strategicContract.column.productQuantity'),
          }, // 商品数量
          {
            prop: 'contractDetailNo',
            label: this.$t('futuresStrategy.strategicContract.column.contractDetailNo'),
          }, // 合同行
        ];
      },
    },
    mounted() {
      this.getDepartment(); //获取部门
    },
    methods: {
      //获取部门
      async getDepartment() {
        const selectStatus = await this.$axios.post(
          BASEAPI.LIST_DEPARTMENT_API + `/${this.userInfo.companyCode}`
        );
        this.departmentList = selectStatus.data.data;
      },
      resetBtnClick() {
        this.$refs.table.clearCheckboxReserve();
        this.getData();
      },
      searchBtnClick() {
        this.$refs.table.clearCheckboxReserve();
        this.getData();
      },
      //编辑表格回显方法
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      openDialog(params) {
        this.defaultVisible = true;
        this.contractDetailList = params;
      },
      // 弹窗确认
      confirm(selections) {
        this.hasExist = false;
        if (selections.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('futuresStrategy.message.noContract'),
            type: 'error',
          });
          return;
        }
        selections.forEach((item) => {
          item.contractDate = item.contractCreateDate;
          this.contractDetailList.some((it) => {
            if (item.contractNo == it.contractNo && item.contractDetailNo == it.contractDetailNo) {
              this.hasExist = true;
              return;
            }
          });
        });
        if (this.hasExist) {
          return this.$message({
            showClose: true,
            message: this.$t('futuresStrategy.message.hasExist'),
            type: 'error',
          });
        }

        this.$emit('handleAdd', selections);
        this.close();
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
    },
  };
</script>
